import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import firebase from "app/Auth";
import { AppDispatch } from "app/store";
import { Loading } from "common/elements";
import { MainLayout } from "features/layout";
import { PlayerPage } from "features/player";
import { AuthPageRoutes } from "features/auth";
import { AccountPage } from "features/account";
import { MessagePage } from "features/message";
import { getAccountUsers } from "features/account/api";
import { NotificationPage } from "features/notification";
import { SubscriptionPage } from "features/subscription";
import { ShakeBugReportDialog } from "features/shared/components/ShakeBugReportDialog";
import { AppLoading } from "./AppLoading";
import { useInitialApp } from "./useInitialApp";
import "react-toastify/dist/ReactToastify.css";

const StartupScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const auth = getAuth(firebase);
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // ユーザーがログイン済みの場合
        try {
          await dispatch(getAccountUsers({ uid: user.uid })).unwrap();
          navigate("/account");
        } catch (error) {
          console.error("Error fetching user:", error);
          navigate("/auth/login");
        }
      } else {
        // 未ログインの場合
        navigate("/auth/login");
      }
    });

    return () => unsubscribe();
  }, [dispatch, navigate]);

  // 認証と口座情報の取得が終わるまでこの画面に留まる。null を返すと
  // 何も描かれず白画面になるので、遷移が終わるまで待ち表示を出し続ける
  return <Loading />;
};

export const AppIndexPage = () => {
  useInitialApp();

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <AppLoading />
      <ShakeBugReportDialog />
      <Routes>
        <Route path="/">
          <Route index element={<StartupScreen />} />
          <Route path="auth/*" element={<AuthPageRoutes />} />
          <Route element={<MainLayout />}>
            <Route path="account" element={<AccountPage />} />
            <Route path="player" element={<PlayerPage />} />
            <Route path="message" element={<MessagePage />} />
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route path="notification" element={<NotificationPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </>
  );
};
